import {
  Box,
  Button,
  AddIcon,
  Divider,
  DividerProps,
  Center,
  useSelectStyles,
} from '@frontend/components';

const CreateDivider = (props: DividerProps) => {
  return <Divider position="absolute" left={0} right={0} {...props} />;
};

export type CreateLabelProps = {
  value: string;
  entity?: string;
  createOptionPosition: 'first' | 'last';
  verb?: string;
  showIcon?: boolean;
};

export const CreateLabel = ({
  value,
  entity = 'new',
  verb = 'Create',
  showIcon = true,
  createOptionPosition,
}: CreateLabelProps) => {
  const styles = useSelectStyles();

  return (
    <>
      <CreateDivider
        {...(createOptionPosition === 'last' ? { top: 0 } : { bottom: 0 })}
      />
      <Center
        as="span"
        {...(createOptionPosition === 'last'
          ? { paddingTop: styles.menuList?.pb }
          : { paddingBottom: styles.menuList?.pt })}
      >
        <Button variant="link" as="strong" w="100%" display="flex">
          {showIcon && <AddIcon size={2.5} marginRight={0.5} />}
          <Box as="span" fontSize="md" flex={1}>
            {verb}&nbsp;{entity}
            {value && <>&nbsp;&ldquo;{value}&rdquo;</>}
          </Box>
        </Button>
      </Center>
    </>
  );
};
